import { render, staticRenderFns } from "./PartnerCompanySave.vue?vue&type=template&id=3d132692"
import script from "./PartnerCompanySave.vue?vue&type=script&lang=js"
export * from "./PartnerCompanySave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports